import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { arlingtonHeightsConfig } from "./data";

export default function ArlingtonHeightsPage() {
  return <CityPageTemplate config={arlingtonHeightsConfig} />;
}